import { productDuplicationInitialState } from 'features/products/redux';

import { RootState } from './rootReducer';

export const initialState: RootState = {
    duplicatedProduct: productDuplicationInitialState,
};

export default initialState;
